import { Route } from 'react-router';

import { ProtectedRoute } from '@app-velocity/request-gateway';

import { AuthRoutesPaths } from '@app-velocity/libs/auth';

import { AuthenticationPage } from '../pages/AuthenticationPage';
import { RegistrationPage } from '../pages/RegistrationPage';
import { ForgotPasswordPage } from '../pages/ForgotPasswordPage';
import { ResetPasswordPage } from '../pages/ResetPasswordPage';
import { AcceptInvitationPage } from '../pages/AcceptInvitationPage';
import { AccountCreated } from '../pages/AccountCreated';
import { AuthPage } from '../pages/AuthPage';
import { AuthSuccessPage } from '../pages/AuthSuccessPage';
import { AuthFailurePage } from '../pages/AuthFailurePage';
import { AuthLayout } from '../layouts/AuthLayout';

// Alias for Route component to avoid confusion with regular route
const LayoutRoute = Route;

export const UserAuthRoutes = (
  <>
    <LayoutRoute element={<AuthLayout />}>
      <Route
        path={AuthRoutesPaths.ForgotPassword}
        element={<ForgotPasswordPage />}
      />
      <Route
        path={AuthRoutesPaths.ResetPassword}
        element={<ResetPasswordPage />}
      />
      <LayoutRoute
        element={<ProtectedRoute redirectPath="/" invertRedirectLogic />}
      >
        <Route path={AuthRoutesPaths.Login} element={<AuthenticationPage />} />
      </LayoutRoute>
      <Route path={AuthRoutesPaths.Auth} element={<AuthPage />} />
      <Route path={AuthRoutesPaths.AuthFailure} element={<AuthFailurePage />} />
      <Route
        path={AuthRoutesPaths.Registration}
        element={<RegistrationPage />}
      />
      <LayoutRoute
        element={<ProtectedRoute redirectPath={AuthRoutesPaths.Registration} />}
      >
        <Route
          path={AuthRoutesPaths.RegistrationAccountCreated}
          element={<AccountCreated />}
        />
      </LayoutRoute>
      <LayoutRoute
        element={
          <ProtectedRoute
            redirectPath={AuthRoutesPaths.Login}
            storeOriginalUrl
          />
        }
      >
        <Route
          path={AuthRoutesPaths.AcceptInvitation}
          element={<AcceptInvitationPage />}
        />
      </LayoutRoute>
    </LayoutRoute>
    <Route path={AuthRoutesPaths.AuthSuccess} element={<AuthSuccessPage />} />
  </>
);
